(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if ( scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-dia-creatina"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tickCountdown(el) {
    var end = new Date(String(el.dataset.end).replace(' ', 'T'));
    if (isNaN(end.getTime())) return;
    var diff = end - new Date();
    if (diff < 0) diff = 0;
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff / 3600000) % 24);
    var m = Math.floor((diff / 60000) % 60);
    var s = Math.floor((diff / 1000) % 60);
    var qd = el.querySelector('[data-days]');
    var qh = el.querySelector('[data-hours]');
    var qm = el.querySelector('[data-mins]');
    var qs = el.querySelector('[data-secs]');
    if (qd) qd.textContent = pad(d);
    if (qh) qh.textContent = pad(h);
    if (qm) qm.textContent = pad(m);
    if (qs) qs.textContent = pad(s);
  }

  function initCountdowns(root) {
    (root || document).querySelectorAll('.sdn-dc [data-countdown]').forEach(function (el) {
      if (el.__sdnStarted) return;
      el.__sdnStarted = true;
      tickCountdown(el);
      setInterval(function () { tickCountdown(el); }, 1000);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sdn-dc__faq-q');
    if (!btn) return;
    var item = btn.parentElement;
    var answer = item.querySelector('.sdn-dc__faq-a');
    var list = item.parentElement;
    var wasOpen = item.classList.contains('is-open');
    list.querySelectorAll('.sdn-dc__faq-item.is-open').forEach(function (i) {
      i.classList.remove('is-open');
      i.querySelector('.sdn-dc__faq-a').style.maxHeight = null;
      var q = i.querySelector('.sdn-dc__faq-q');
      if (q) q.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('is-open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountdowns(); });
  } else {
    initCountdowns();
  }

  document.addEventListener('shopify:section:load', function (e) { initCountdowns(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-lp-12anos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.sdn-anv__fade-up:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function copy(text, btn) {
    if (navigator.clipboard) { navigator.clipboard.writeText(text).catch(function () {}); }
    if (btn) {
      var old = btn.textContent;
      btn.textContent = 'Copiado!';
      setTimeout(function () { btn.textContent = old; }, 1500);
    }
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('.sdn-anv [data-copy]');
    if (!el) return;
    copy(el.getAttribute('data-copy'), el.matches('button') ? el : null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else { reveal(); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-lp-like-kids"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupHero(root) {
    var track = root.querySelector('.sdn-lk__hero-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sdn-lk__hero-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sdn-lk__hero-dot'));
    var prev = root.querySelector('.sdn-lk__hero-arrow--prev');
    var next = root.querySelector('.sdn-lk__hero-arrow--next');
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
      dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
    }
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (el, idx) { el.addEventListener('click', function () { show(idx); }); });
  }

  // Carrossel dos perks no mobile: mesmo padrão do ec-announcement-banner
  // (home) — clona os slides nas duas pontas pra loop infinito + auto-rotate,
  // some sozinho acima de 749px (aí é a grade normal, sem JS nenhum).
  function setupPerks(track) {
    if (!track || track.hasAttribute('data-sdn-lk-perks-init')) return;
    track.setAttribute('data-sdn-lk-perks-init', '1');
    var originalCount = track.querySelectorAll('.sdn-lk__perk-slide').length;
    if (originalCount < 2) return;

    var cloned = false;
    var autoTimer = null;
    var AUTO_MS = 3500;

    function isMobile() { return window.innerWidth <= 749; }
    function slideWidth() {
      var first = track.querySelector('.sdn-lk__perk-slide');
      return first ? first.offsetWidth : track.offsetWidth;
    }
    function lapWidth() { return originalCount * slideWidth(); }

    function onScrollWrap() {
      if (!isMobile() || !cloned) return;
      var lap = lapWidth();
      if (lap <= 0) return;
      if (track.scrollLeft >= 2 * lap - 2) track.scrollLeft -= lap;
      if (track.scrollLeft <= 2) track.scrollLeft += lap;
    }
    function goNext() {
      if (!isMobile() || !cloned) return;
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    }
    function startAuto() {
      stopAuto();
      if (isMobile() && cloned) autoTimer = setInterval(goNext, AUTO_MS);
    }
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    function restartAutoDelayed() { setTimeout(startAuto, 3000); }

    function initMobile() {
      if (!isMobile() || cloned) return;
      var base = Array.prototype.slice.call(track.querySelectorAll('.sdn-lk__perk-slide:not([data-clone])'));
      if (base.length !== originalCount) return;
      var fragEnd = document.createDocumentFragment();
      var fragStart = document.createDocumentFragment();
      base.forEach(function (el) {
        var c1 = el.cloneNode(true); c1.setAttribute('data-clone', '1'); fragEnd.appendChild(c1);
        var c2 = el.cloneNode(true); c2.setAttribute('data-clone', '1'); fragStart.appendChild(c2);
      });
      track.appendChild(fragEnd);
      track.insertBefore(fragStart, track.firstChild);
      cloned = true;
      var lap = lapWidth();
      if (lap > 0) requestAnimationFrame(function () { track.scrollLeft = lap; });
      track.addEventListener('scroll', onScrollWrap, { passive: true });
      track.addEventListener('touchstart', stopAuto, { passive: true });
      track.addEventListener('touchend', restartAutoDelayed, { passive: true });
      startAuto();
    }

    function destroyMobile() {
      if (!cloned) return;
      Array.prototype.slice.call(track.querySelectorAll('[data-clone="1"]')).forEach(function (el) { el.remove(); });
      cloned = false;
      track.scrollLeft = 0;
      stopAuto();
      track.removeEventListener('scroll', onScrollWrap);
      track.removeEventListener('touchstart', stopAuto);
      track.removeEventListener('touchend', restartAutoDelayed);
    }

    function checkViewport() { isMobile() ? initMobile() : destroyMobile(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkViewport);
    } else {
      checkViewport();
    }
    window.addEventListener('resize', checkViewport);
  }

  document.querySelectorAll('.sdn-lk__hero').forEach(setupHero);
  document.querySelectorAll('.sdn-lk__perks-inner').forEach(setupPerks);
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('.sdn-lk__hero');
    if (hero) setupHero(hero);
    var perks = e.target.querySelector('.sdn-lk__perks-inner');
    if (perks) setupPerks(perks);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-lp-olympia-2027-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  function maskPhone(v) {
    var d = String(v || '').replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function bindForm(form) {
    if (form.__sdnOly27Bound) return;
    form.__sdnOly27Bound = true;

    var okMsg = form.querySelector('[data-success-msg]');
    var errMsg = form.querySelector('[data-error-msg]');
    var btn = form.querySelector('button[type="submit"]');

    var tel = form.querySelector('[name="whatsapp"]');
    if (tel) tel.addEventListener('input', function () { tel.value = maskPhone(tel.value); });

    // O "Project URL" do dashboard é só o host, mas é fácil colar já com o
    // caminho da API junto — sem esta limpeza vira .../rest/v1/rest/v1/tabela.
    var supabaseUrl = (form.getAttribute('data-supabase-url') || '')
      .trim().replace(/\/+$/, '').replace(/\/rest\/v1$/, '');
    var supabaseKey = form.getAttribute('data-supabase-key');
    var supabaseTable = form.getAttribute('data-supabase-table') || 'olympia_2027_leads';

    // O botão desabilitado não impede um segundo submit: Enter dentro de um
    // campo dispara o evento direto, sem passar pelo botão. Sem esta flag o
    // cadastro grava em duplicata — foi o que já aconteceu na sales_reps.
    var enviando = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return;
      if (okMsg) okMsg.hidden = true;
      if (errMsg) errMsg.hidden = true;
      if (!form.checkValidity()) { form.reportValidity(); return; }

      if (!supabaseUrl || !supabaseKey) {
        console.error('[sdn-oly27] faltou data-supabase-url/key no formulário.');
        if (errMsg) { errMsg.textContent = 'Formulário indisponível no momento.'; errMsg.hidden = false; }
        return;
      }

      var q = function (name) { return form.querySelector('[name="' + name + '"]'); };

      // honeypot: bot preenche até campo escondido. Finge sucesso e não envia
      // nada — não é pra dar dica de que foi filtrado.
      if (((q('website') || {}).value || '').trim() !== '') {
        if (okMsg) { okMsg.textContent = form.getAttribute('data-success') || 'Cadastro enviado!'; okMsg.hidden = false; }
        form.reset();
        return;
      }

      var telDigits = ((q('whatsapp') || {}).value || '').replace(/\D/g, '');
      if (telDigits.length !== 11) {
        var telEl = q('whatsapp');
        if (errMsg) { errMsg.textContent = 'Informe um WhatsApp válido com DDD — ex: (11) 91234-5678.'; errMsg.hidden = false; }
        if (telEl) telEl.focus();
        return;
      }

      // Colunas exatamente como a tabela `olympia_2027_leads` espera.
      var carga = {
        nome: (q('nome') || {}).value || '',
        whatsapp: (q('whatsapp') || {}).value || '',
        email: (q('email') || {}).value || '',
        instagram: (q('instagram') || {}).value || '',
        cidade: (q('cidade') || {}).value || '',
        ja_e_cliente: (q('ja_e_cliente') || {}).value === 'sim',
        produto: (q('produto') || {}).value || '',
        faixa_consumo: (q('faixa_consumo') || {}).value || '',
      };

      var original = btn ? btn.textContent : '';
      enviando = true;
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }

      function liberar() {
        enviando = false;
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }

      fetch(supabaseUrl + '/rest/v1/' + supabaseTable, {
        method: 'POST',
        headers: {
          apikey: supabaseKey,
          Authorization: 'Bearer ' + supabaseKey,
          'Content-Type': 'application/json',
          Prefer: 'return=minimal',
        },
        body: JSON.stringify(carga),
      })
        .then(function (res) {
          if (res.ok) {
            if (okMsg) { okMsg.textContent = form.getAttribute('data-success') || 'Cadastro enviado!'; okMsg.hidden = false; }
            form.reset();
            liberar();
            return;
          }
          liberar();
          return res.text().then(function (corpo) {
            console.error('[sdn-oly27]', res.status, corpo);
            if (errMsg) { errMsg.textContent = form.getAttribute('data-error') || 'Erro ao enviar.'; errMsg.hidden = false; }
          });
        })
        .catch(function (err) {
          liberar();
          console.error('[sdn-oly27]', err);
          if (errMsg) { errMsg.textContent = form.getAttribute('data-error') || 'Erro ao enviar.'; errMsg.hidden = false; }
        });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.sdn-oly27__form').forEach(bindForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-lp-olympia"] && !Shopify.designMode) return;
  try {
    
(function () {
  // máscara de telefone BR: (11) 91234-5678 (celular) ou (11) 3456-7890 (fixo)
  function maskPhone(v) {
    var d = String(v || '').replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function bindForm(form) {
    if (form.__sdnBound) return;
    form.__sdnBound = true;
    var okMsg = form.querySelector('[data-success-msg]');
    var errMsg = form.querySelector('[data-error-msg]');
    var btn = form.querySelector('button[type="submit"]');

    var tel = form.querySelector('[name="telefone"]');
    if (tel) tel.addEventListener('input', function () { tel.value = maskPhone(tel.value); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (okMsg) okMsg.hidden = true;
      if (errMsg) errMsg.hidden = true;
      if (!form.checkValidity()) { form.reportValidity(); return; }

      var url = form.getAttribute('data-webhook');
      if (!url) {
        if (errMsg) { errMsg.textContent = 'Formulário sem destino configurado.'; errMsg.hidden = false; }
        return;
      }

      var q = function (name) { return form.querySelector('[name="' + name + '"]'); };
      var fail = function (el, msg) { if (errMsg) { errMsg.textContent = msg; errMsg.hidden = false; } if (el) el.focus(); };

      // nome completo (nome + sobrenome)
      var nomeEl = q('nome');
      var nomeVal = ((nomeEl || {}).value || '').trim();
      if (nomeVal.split(/\s+/).filter(Boolean).length < 2 || nomeVal.length < 5) {
        return fail(nomeEl, 'Informe seu nome completo (nome e sobrenome).');
      }

      // celular completo (11 dígitos com DDD)
      var telEl = q('telefone');
      var telDigits = ((telEl || {}).value || '').replace(/\D/g, '');
      if (telDigits.length !== 11) {
        return fail(telEl, 'Informe um celular válido com DDD — ex: (11) 91234-5678.');
      }

      // motivo com conteúdo real
      var motivoEl = q('por_que_merece');
      if (((motivoEl || {}).value || '').trim().length < 20) {
        return fail(motivoEl, 'Conta um pouco mais sobre por que você merece (mínimo 20 caracteres).');
      }

      var lgpd = q('consentimento_lgpd');
      var payload = {
        nome: (q('nome') || {}).value || '',
        numero_pedido: (q('numero_pedido') || {}).value || '',
        telefone: (q('telefone') || {}).value || '',
        por_que_merece: (q('por_que_merece') || {}).value || '',
        confirma_passaporte_visto: !!(q('confirma_passaporte_visto') || {}).checked,
        consentimento_lgpd: lgpd ? !!lgpd.checked : true,
        website: (q('website') || {}).value || '',
      };

      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .then(function (res) {
          if (res && res.ok) {
            if (okMsg) { okMsg.textContent = form.getAttribute('data-success') || 'Resposta enviada!'; okMsg.hidden = false; }
            form.reset();
          } else if (errMsg) {
            errMsg.textContent = (res && res.error) ? res.error : (form.getAttribute('data-error') || 'Erro ao enviar.');
            errMsg.hidden = false;
          }
        })
        .catch(function () {
          if (errMsg) { errMsg.textContent = form.getAttribute('data-error') || 'Erro ao enviar.'; errMsg.hidden = false; }
        })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.sdn-oly__form[data-webhook]').forEach(bindForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-lp-sowd-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sdn-sowd__slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sdn-sowd__carrossel-dot'));
    var prev = root.querySelector('.sdn-sowd__carrossel-seta--prev');
    var next = root.querySelector('.sdn-sowd__carrossel-seta--next');
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
      dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
    }
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (el, idx) { el.addEventListener('click', function () { show(idx); }); });
  }

  document.querySelectorAll('.sdn-sowd__carrossel').forEach(setup);
  document.addEventListener('shopify:section:load', function (e) {
    var carrossel = e.target.querySelector('.sdn-sowd__carrossel');
    if (carrossel) setup(carrossel);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sdn-quem-somos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var els = scope.querySelectorAll('.sdn-qs__reveal:not(.is-in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        Array.prototype.forEach.call(els, function (el) {
          el.classList.add('is-in');
        });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
      );
      Array.prototype.forEach.call(els, function (el) {
        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        reveal();
      });
    } else {
      reveal();
    }
    document.addEventListener('shopify:section:load', function (e) {
      reveal(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
